import * as React from "react";
const SVGComponent = ({ color = "var(--text-secondary)", ...props }) => (
  <svg
    width={26}
    height={24}
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.0405 1.91939C14.6029 1.17889 13.8623 0.741211 12.9873 0.741211C12.1123 0.741211 11.3718 1.17885 10.9341 1.91939L0.802874 19.7248C0.399042 20.4653 0.399042 21.3404 0.802874 22.0809C1.24051 22.8214 1.98105 23.2591 2.85606 23.2591H23.1186C23.9601 23.2591 24.7342 22.8214 25.1718 22.0809C25.6094 21.3404 25.6094 20.4653 25.1718 19.7248L15.0405 1.91939ZM23.4215 21.0712C23.388 21.1386 23.287 21.2395 23.1187 21.2395H2.85611C2.68777 21.2395 2.58681 21.1386 2.55324 21.0712C2.51966 21.0038 2.45228 20.8693 2.55324 20.7345L12.6845 2.89539C12.7519 2.76086 12.9202 2.72705 12.9874 2.72705C13.0548 2.72705 13.1893 2.76062 13.2903 2.89539L23.4215 20.7345C23.4887 20.869 23.4551 21.0036 23.4215 21.071V21.0712Z"
      fill={color}
    />
    <path
      d="M13.1211 8.24707C12.549 8.24707 12.1113 8.68471 12.1113 9.25689V13.969C12.1113 14.5412 12.549 14.9788 13.1211 14.9788C13.6933 14.9788 14.131 14.5412 14.131 13.969V9.25689C14.131 8.7183 13.6936 8.24707 13.1211 8.24707Z"
      fill={color}
    />
    <path
      d="M13.1211 15.9883C12.549 15.9883 12.1113 16.4259 12.1113 16.9981V18.0079C12.1113 18.5801 12.549 19.0177 13.1211 19.0177C13.6933 19.0177 14.131 18.5801 14.131 18.0079V16.9981C14.131 16.4595 13.6936 15.9883 13.1211 15.9883Z"
      fill={color}
    />
  </svg>
);
export default SVGComponent;
